import { AxiosPromise } from "axios";
import API from "./Api";
import { ACCOUNT_DELETE, ACCOUNT_DELETE_PREFLIGHT } from "./constants";

export default class AccountDeletionApi {
  static preflight(): AxiosPromise {
    return API.post(ACCOUNT_DELETE_PREFLIGHT);
  }

  static deleteAccount(reason: string): AxiosPromise {
    return API.post(ACCOUNT_DELETE, { reason, force: false });
  }
}
